//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
    }
  },
  computed: {
    isEn() {
      return this.$i18n.locale === 'en'
    },
    queryLang() {
      return this.isEn ? '?lang=en' : ''
    }
  },
}
